<div class="header">Follow-Up Notifications</div>

<div class="follow-ups">
  <ng-container *ngFor="let followUp of followUpRows">
    <div class="follow-up" [class.highlight-yellow]="followUp.isUnread">
      <div class="body ckeditor-text" [innerHTML]="followUp.message"></div>
      <div class="timestamp">{{ followUp.addedDate | date: dateFormat }}</div>
    </div>
  </ng-container>
</div>
